import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { NavLink } from "react-router-dom"; // Adjusted import
import ConfirmDeleteModal from './ConfirmationModelDelete';
import './List.css';
import axios from 'axios';

const ListBrandsNew = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [userData, setUserData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const history = useHistory();
  const token = localStorage.getItem('authToken');

  // Fetch user data with pagination and search
  const fetchUserData = async () => {
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/brandsnew`, {
        params: { page: currentPage, limit, search: searchQuery },
        headers: { Authorization: `Bearer ${token}` }
      });
      setUserData(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const handleDownloadCSV = () => {
    const headers = [
      'S.No',
      'Name',
      
      'Date'
    ];
  
    const csvRows = [];
    csvRows.push(headers.join(',')); // Add headers as the first row
  
    userData.forEach((brand, index) => {
      const row = [
        (currentPage - 1) * limit + index + 1, // Serial number
        brand?.name || 'N/A', // Name
      
        formatDate(brand?.createdAt) // Formatted Date
      ];
  
      csvRows.push(row.join(',')); // Add the row to CSV rows
    });
  
    const csvBlob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement('a');
    link.href = csvUrl;
    link.download = 'brands_list.csv';
    link.click();
  };
  const handleEdit = (id) => history.push(`/edit-brandsNew/${id}`);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://brand.aasmo.in/api/admin/brandsnew/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchUserData(); // Refresh data after deletion
    } catch (error) {
      console.error("Error deleting category:", error);
    }
    setShowModal(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedUserId(id);
    setShowModal(true);
  };

  const formatDate = (dateString) => new Date(dateString).toLocaleDateString(undefined, {
    year: 'numeric', month: 'long', day: 'numeric'
  });

  const handlePageChange = (page) => setCurrentPage(page);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  useEffect(() => {
    fetchUserData();
  }, [currentPage, searchQuery]);

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>List Brands</h2>
        </div>
        <div className="body">
          {/* Search Input */}
          <div className="d-flex justify-content-between">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search by Name"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
          <div>
       <button onClick={handleDownloadCSV} className="btn btn-primary">
            Download CSV
          </button>
       </div>
       </div>
          <div className="table-responsive">
            <table className="table table-hover">
              <thead style={{ textAlign: "center" }}>
                <tr>
                  <th>#</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: "center" }}>
                {userData.map((user, index) => (
                  <tr key={user.id}>
                    <td>{index + 1}</td>
                    <td>
                      {user.image && (
                        <img 
                          src={user.image} 
                          alt="image" 
                          style={{ width: "50px", height: "50px", borderRadius: "50%" }} 
                        />
                      )}
                    </td>
                    <td>{user.name}</td>
                    <td>{formatDate(user.createdAt)}</td>
                    <td>
                      <i className="icon-pencil" onClick={() => handleEdit(user._id)}></i>
                      &nbsp;&nbsp;
                      <i className="fa fa-trash-o" onClick={() => handleDeleteClick(user._id)}></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedUserId)}
      />
    </div>
  );
};

export default ListBrandsNew;
